import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import React, { useEffect } from 'react';
import config from 'utils/config';
import { useFetchUserHelixAccess } from 'actions/users';
import { getAgentElement } from '../getAgentElement';
import { useMindsetUploadTranscriptModalTool } from './useMindsetUploadTranscriptModalTool';
import { useMindsetManageCalendarModalTool } from './useMindsetManageCalendarModalTool';
import { useMindsetContactFormModalTool } from './useMindsetContactFormModalTool';
import { useMindsetAnalyzeUploadedTranscriptTool } from './useMindsetAnalyzeUploadedTranscriptTool';
import { Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export function useMindsetPageTools(isInitialized, containerId,
// Bump to re-attach tools when the agent element is replaced after init
// (see useMindsetCardAgent's renderGeneration).
resyncKey) {
  var _useFetchUserHelixAcc = useFetchUserHelixAccess(),
    helixAccessData = _useFetchUserHelixAcc.data;
  var _ref = helixAccessData || {},
    isHelixHub = _ref.isHelixHub,
    isHelixUser = _ref.hasAccess;
  var hasHelixAccess = Boolean(isHelixHub) && Boolean(isHelixUser);
  var canUploadTranscripts = hasHelixAccess && config.helixAllowMeetingTranscriptUpload;
  var canManageCalendar = hasHelixAccess && config.userCalendarIntegration;
  var _useMindsetUploadTran = useMindsetUploadTranscriptModalTool(containerId),
    uploadTranscriptTool = _useMindsetUploadTran.tool,
    uploadTranscriptModal = _useMindsetUploadTran.modal;
  var _useMindsetAnalyzeUpl = useMindsetAnalyzeUploadedTranscriptTool(containerId),
    analyzeUploadedTranscriptTool = _useMindsetAnalyzeUpl.tool;
  var _useMindsetManageCale = useMindsetManageCalendarModalTool(containerId),
    manageCalendarTool = _useMindsetManageCale.tool,
    manageCalendarModal = _useMindsetManageCale.modal;
  var _useMindsetContactFor = useMindsetContactFormModalTool(containerId),
    contactFormTool = _useMindsetContactFor.tool;
  useEffect(function () {
    if (!isInitialized) return;
    var agentEl = getAgentElement(containerId);
    if (!(agentEl !== null && agentEl !== void 0 && agentEl.setPageTools)) return;
    var tools = [canUploadTranscripts ? uploadTranscriptTool : null, canUploadTranscripts ? analyzeUploadedTranscriptTool : null, canManageCalendar ? manageCalendarTool : null, contactFormTool].filter(function (tool) {
      return tool !== null;
    });
    function registerTools() {
      var _agentEl$setPageTools;
      agentEl === null || agentEl === void 0 || (_agentEl$setPageTools = agentEl.setPageTools) === null || _agentEl$setPageTools === void 0 || _agentEl$setPageTools.call(agentEl, tools);
    }
    agentEl.addEventListener('mindset:agent-idle', registerTools);
    return function () {
      return agentEl.removeEventListener('mindset:agent-idle', registerTools);
    };
  }, [isInitialized, containerId, resyncKey, canUploadTranscripts, canManageCalendar, uploadTranscriptTool, manageCalendarTool, contactFormTool, analyzeUploadedTranscriptTool]);
  return {
    modals: /*#__PURE__*/_jsxs(_Fragment, {
      children: [canUploadTranscripts && uploadTranscriptModal, canManageCalendar && manageCalendarModal]
    })
  };
}